<template>
  <div class="container">
    <h3 class="title">Dane nie zostały odnalezione.</h3>
    <div class="btn-group">
      <a :href="`tel:${$phone}`" class="btn" :style="{ background: $color }">Telefon</a>
      <button type="button" class="btn" :style="{ background: $color }" @click="setHomePage">Menu</button>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "NoResult",
  methods: {
    ...mapMutations(["setHomePage"]),
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/case_steps/NoResult.vue